import { Injectable } from '@angular/core';
import { RegistrationBasketStore, RegistrationBasketState } from './registration-basket.store';
import { Query } from '@datorama/akita';

@Injectable({ providedIn: 'root' })
export class RegistrationBasketQuery extends Query<RegistrationBasketState> {

  constructor(protected store: RegistrationBasketStore) {
    super(store);
  }

}
